import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FlexRow, Gap } from 'ui-components/components/flex';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { ItemsToScanTable } from './items-to-scan-table';
import { messages } from './messages';
import { ScanInput } from './scan-input';
import { useScanVerificationContext } from './scan-verification-context-provider';
import style from './styles.module.less';
import { InvalidScanWarningModal } from '../../../../../../scan/verify/invalid-scan-warning-modal';

export const ScanToVerify = () => {
  const {
    warningType,
    showInvalidScanModal,
    closeInvalidScanModal,
    isSubmitting,
    isVerified,
    verifyAllItems,
    clearAllItems,
    verifiedItemCounts,
  } = useScanVerificationContext();

  const hasAnyVerifiedCounts = useMemo(() => {
    return Object.values(verifiedItemCounts).some((count) => count > 0);
  }, [verifiedItemCounts]);

  return (
    <>
      {showInvalidScanModal && warningType ? (
        <InvalidScanWarningModal closeModal={closeInvalidScanModal} warningType={warningType} />
      ) : null}
      <div className={style['list-container']}>
        <FlexRow className={style['scan-actions']} gap={Gap.Space32}>
          <ScanInput />
          <FlexRow gap={Gap.Space8}>
            <Button disabled={isVerified || isSubmitting} onClick={verifyAllItems} theme={THEME_CONSTANTS.secondary}>
              <FormattedMessage {...messages.verifyAll} />
            </Button>
            <Button disabled={!hasAnyVerifiedCounts || isSubmitting} onClick={clearAllItems} theme={THEME_CONSTANTS.tertiary}>
              <FormattedMessage {...messages.clearAll} />
            </Button>
          </FlexRow>
        </FlexRow>
        <ItemsToScanTable />
      </div>
    </>
  );
};
